import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/stacyharrison/Desktop/code/stasquatch.github.io/src/templates/post.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Quick look`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Required?`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sort of?`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Common attributes`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`typically none`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Common aria`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`none allowed`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Summary`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`body`}</inlineCode>{` tag is where nearly all your presentational HTML will go.
It's considered a section element, in good company with `}<inlineCode parentName="p">{`nav`}</inlineCode>{`, `}<inlineCode parentName="p">{`section`}</inlineCode>{`,
and others. Section elements are used to provide meaningful structure
to the page, so that browsers and assistive devices have more context
to the content within each element. For example, a `}<inlineCode parentName="p">{`nav`}</inlineCode>{` should be
interpreted differently than a `}<inlineCode parentName="p">{`body`}</inlineCode>{` element.`}</p>
    <p>{`While it's not strictly required, it's good practice to include it. If
you omit the tag, browsers will usually insert it for you. Because
browsers can have different behavior, you `}<em parentName="p">{`may`}</em>{` get unexpected side effects
relying on this implementation. Explicitly defining the `}<inlineCode parentName="p">{`body`}</inlineCode>{` tag also
allows you to define the language of the document, if you haven't already
defined it on the `}<inlineCode parentName="p">{`html`}</inlineCode>{` tag.`}</p>
    <p><inlineCode parentName="p">{`body`}</inlineCode>{` must be the second child of the `}<inlineCode parentName="p">{`html`}</inlineCode>{` tag (`}<inlineCode parentName="p">{`head`}</inlineCode>{` being the first child).`}</p>
    <p>{`In JavaScript, you can access the body element via `}<inlineCode parentName="p">{`document.body`}</inlineCode>{`.`}</p>
    <h3>{`Attributes`}</h3>
    <p><inlineCode parentName="p">{`lang`}</inlineCode></p>
    <p>{`While you can set the `}<inlineCode parentName="p">{`lang`}</inlineCode>{` and `}<inlineCode parentName="p">{`dir`}</inlineCode>{` on a `}<inlineCode parentName="p">{`body`}</inlineCode>{` tag, you typically should set it
on the `}<inlineCode parentName="p">{`html`}</inlineCode>{` instead. Setting the `}<inlineCode parentName="p">{`lang`}</inlineCode>{` on `}<inlineCode parentName="p">{`body`}</inlineCode>{` means all the meta information
in the `}<inlineCode parentName="p">{`head`}</inlineCode>{` tag will be lacking the language declaration.`}</p>
    <p><a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes"
      }}>{`Global attributes`}</a></p>
    <h3>{`Usage`}</h3>
    <pre><code parentName="pre" {...{}}>{`<!DOCTYPE html>
<html lang="en">
  <head>
    …
  </head>
  <body>
    …
  </body>
</html>
`}</code></pre>
    <p><em parentName="p">{`Note: `}<inlineCode parentName="em">{`…`}</inlineCode>{` denotes miscellaneous HTML, removed for brevity.`}</em></p>
    <h3>{`Links`}</h3>
    <p><a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/body"
      }}>{`MDN: The body tag`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/Using_HTML_sections_and_outlines#sectioning_roots"
      }}>{`MDN: Section elements`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://www.w3.org/International/questions/qa-html-language-declarations"
      }}><inlineCode parentName="a">{`lang`}</inlineCode>{` tag on `}<inlineCode parentName="a">{`html`}</inlineCode>{` instead of `}<inlineCode parentName="a">{`body`}</inlineCode></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      